import axios from "axios";

export const read = async (skip,query, searchThis,address1,status,khusus) => {
    try{
        return axios.get(`${process.env.REACT_APP_BACKEND_URL}/listSuratMasukCompany?skip=${skip}&query=${query}&SearchThis=${searchThis}&lokasi=${address1}&status=${status}&khusus=${khusus}`,{
        })
    } catch(error){
        throw new Error(error);
    }
}